module.exports = __webpack_public_path__ + "static/media/create.d6b23e62.svg";